// ## italics: true 斜体
// ## blod 加粗
// ## alignment: 'center' 文字居中
// ## alignment: 'justify', 单行字间距相等
// ## width height 宽高
// ## margin: [0, 190, 0, 80] 外边距
// ## opacity: 0.5
// ## pageBreak: 'after' 稍后分页？？
// ## fit: [200, 200] 放在一个矩形内
// ## page numbers 页码
// ## page count 页数
// ##	pageMargins: [ 30, 60, 30, 60 ], 页面边距
export  const reportData = {
	pageMargins: [ 30, 60, 30, 75 ],
	header: [
		// { canvas: [ { type: 'line', x1: 30, y1: 0, x2: 570, y2: 0,lineWidth:0.5 } ] }
	],
	footer:{type:'function', arguments:"currentPage, pageCount",body:`return [
				{ canvas: [ { type: 'line', x1: 30, y1: 0, x2: 570, y2: 0,lineWidth:0.5 } ] },
				{
					columns: [
						{
							text: '页码：'+1 + '/' + 2,
							style:['patientsInfo','titleMargin'],
							alignment: 'right'
						},
					],
					margin: [30,0,30,0]
				}
			];`
	 },//  function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },
	content: [
		{text:"皮肤肿物切除术/组织活检术知情同意书", alignment: 'center',fontSize: 18,bold: false,margin: [0,5,0,0]},
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		

		{   
            id:"patientsName",
			columns: [
				{
					text: [{text: '患者姓名：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text: [{text: '性别：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text: [{text: '年龄：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text:[{text: 'ID号：',  bold: true}],
                    style:'patientsInfo',
                    width:'30%'
				},
			],
			style:['patientsInfo','titleMargin']

		},
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		{
			text:[{text: '疾病介绍和治疗建议',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '治疗前诊断及主要病情介绍：',  bold: false}],
					style:'patientsInfo',
					width:'480'
				},
				{
					text: '',
					width:'480'
				},
			],
			style:['patientsInfo','titleMargin'],
			width:'480'
		},
		{
			id:"diagnoses",
			text: '',
			style:['patientsInfo'],
			width:'480',
			margin: [20,10,0,10]
		},
		{
			id:"complaint",
			text: '本病例主要高危因素：',
			style:['patientsInfo','titleMargin'],
			width:'480',
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '☐手术部位特殊，易损伤神经、血管；☐手术部位容易影响美观；☐肿物巨大；☐高血压；☐糖尿病；☐心脏病；☐脑血管病；☐凝血功能障碍；☐敏感体质；☐瘢痕体质；☐其他疾病。',  bold: false}],
					style:'patientsInfo',
					width:'100%'
				},
			],
			style:['patientsInfo','titleMargin'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '治疗后应当注意的主要事项：遵医嘱，局部保持干燥清洁、预防感染、定期复查、按照医嘱日期进行换药、拆线。',  bold: false}],
					style:['patientsInfo','chapter'],
					width:'100%'
				},
			],
			style:['patientsInfo','titleMargin'],
		},
		{   
            id:"notice",
			columns: [
				{
					text: [{text: '.      医生已告知我患有&疾病，需要在0.9%利多卡因注射液局部麻醉下进行手术切除/皮肤组织活检术。本病为☐慢性复杂性；☐急性复杂性；☐肿瘤性皮肤病，病因不清楚，如不及时活检/治疗可能☐不能明确诊断，影响下一步治疗；☐病情进一步进展。',  bold: false}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '手术切除的目的是为了彻底清除病灶，组织活检术目的是明确诊断，以便制定有针对性的治疗方案。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '手术目的：手术切除的目的是为了彻底清除病灶，组织活检术目的是明确诊断。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '手术可能的受益：清除病灶，或明确诊断，以便制定有针对性的治疗方案。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
			margin: [0,10,0,0]
		},
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		{
			text:[{text: '替代医疗方案：',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '.      根据您的病情，除上述皮肤肿物切除术/组织活检术治疗方式外，目前我院可以做的其他治疗方法和（或）手术方式有：'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','titleMargin'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '1、☐保守治疗。2、☐继续观察。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '3、☐药物治疗。4、☐激光治疗。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '5、☐冷冻治疗。 6、☐光疗。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
			margin: [0,10,0,0]
		},
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		{
			text:[{text: '手术潜在风险和对策：',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '.      医生告知我如下皮肤肿物切除术/组织活检术可能发生的风险，基于现在医学技术的局限性，除医生已经告知内容外，还有一些罕见、特殊、不可预测的并发症与医疗风险，医师不可能做到在此全面的告知，有些不常见的风险可能没有在此列出，我对此予以理解。具体的手术式根据不同病人的情况有所不同，医生告诉我可与我的医生讨论有关我手术的具体内容，如果我有特殊的问题可与我的医生讨论。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','titleMargin'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '1.我理解任何手术麻醉都存在风险。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '2.我理解任何所用药物都可能产生副作用，包括轻度的恶心、皮疹等症状到严重的过敏性休克，甚至危及生命。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '3.我理解此手术存在以下风险和局限性：'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '（1）    局部出血；'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '（2）    局部神经损伤；'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '（3）    创口感染；'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '（4）    由于皮损周围局部使用外用消毒液造成皮肤黏膜（尤其是结膜、耳道、鼻腔、口腔等部位）出现刺激症状；'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		// {   
        //     id:"complaint",
		// 	columns: [
		// 		{
		// 			text: [{text: '（4）    创口愈合不良；'}],
		// 			style:['patientsInfo','titleMargin'],
		// 			width:'100%'
		// 		},
		// 	],
		// 	style:['patientsInfo'],
		// },
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '（5）    创口愈合不良或局部瘢痕形成；'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		
	],
	styles: {
		title:{
			margin: [30,5],
			fontSize: 12,
			// bold: false
		},
		titleMargin:{
			margin:[0,4,0,0]
		},
		DTT:{
			width:50
		},
		patientsInfo:{
			fontSize: 10
		},
		small: {
			fontSize: 8
		},
		chapter:{
			margin: [0,12,0,0]
		},
		textIndent:{
			margin: [25,0,0,0]
		}
	}
	
};